import { getCleanPath } from "./publicPaths";

/**
 * @param {string} pathname
 * @param {string} candidate
 * @returns {boolean}
 */
export function pathMatchesWhatsAppPrefix(pathname, candidate) {
  if (typeof pathname !== "string" || typeof candidate !== "string" || !candidate) {
    return false;
  }
  if (candidate === "/") {
    return pathname === "/";
  }
  const prefix = candidate.endsWith("/") ? candidate.slice(0, -1) : candidate;
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/**
 * @param {string} raw
 * @param {string[]} fallback
 * @returns {string[]}
 */
export function parseWhatsAppPathList(raw, fallback) {
  if (typeof raw !== "string" || !raw.trim()) {
    return fallback;
  }
  return raw
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

/**
 * @param {string} raw
 * @returns {string}
 */
export function normalizeWhatsAppPhone(raw) {
  if (typeof raw !== "string") {
    return "";
  }
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith("00")) {
    digits = digits.slice(2);
  }
  if (digits.length === 9 && /^[679]/.test(digits)) {
    digits = `34${digits}`;
  }
  if (digits.length < 8 || digits.length > 15) {
    return "";
  }
  return digits;
}

/**
 * @param {string} phone
 * @param {string} [message]
 * @returns {string}
 */
export function buildWhatsAppHref(phone, message) {
  const digits = normalizeWhatsAppPhone(phone);
  if (!digits) {
    return "";
  }
  const base = `https://wa.me/${digits}`;
  const text = typeof message === "string" ? message.trim() : "";
  if (!text) {
    return base;
  }
  return `${base}?text=${encodeURIComponent(text)}`;
}

/**
 * @param {string} pathname
 * @param {string[]} visiblePaths
 * @param {string[]} hiddenPaths
 * @returns {boolean}
 */
export function shouldShowWhatsAppFloat(pathname, visiblePaths, hiddenPaths) {
  const clean = getCleanPath(pathname);
  if (!Array.isArray(visiblePaths) || visiblePaths.length === 0) {
    return false;
  }
  const hidden = Array.isArray(hiddenPaths) ? hiddenPaths : [];
  if (hidden.some((path) => pathMatchesWhatsAppPrefix(clean, path))) {
    return false;
  }
  return visiblePaths.some((path) => pathMatchesWhatsAppPrefix(clean, path));
}
